var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSecuritySmallActiveCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0F4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M7 20c7.04 0 7-3.044 7-6.787v-4.01c0-.898-.754-1.628-1.68-1.628h-.549v-2.95C11.771 2.076 9.631 0 7 0 4.37 0 2.229 2.075 2.229 4.626v2.949H1.68c-.926 0-1.68.73-1.68 1.629v4.01C0 16.955-.04 20 7 20zM3.64 4.335c0-1.603 1.507-2.906 3.36-2.906s3.36 1.303 3.36 2.906v3.15H3.64v-3.15zm-1.504 4.58h9.672c.421 0 .764.328.764.732v3.608c0 2.963.131 5.374-5.6 5.374s-5.6-2.411-5.6-5.374V9.647c0-.404.343-.733.764-.733z",
    transform: "translate(-335 -51) translate(335 51)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10.857c-.773 0-1.4.617-1.4 1.378 0 .545.322 1.016.79 1.24l-.615 1.954h2.414l-.613-1.938c.486-.216.824-.698.824-1.256 0-.761-.627-1.378-1.4-1.378z",
    transform: "translate(-335 -51) translate(335 51)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecuritySmallActiveCopy);
export default __webpack_public_path__ + "static/media/icon-security-small-active-copy.fc96a91f4016f19561ebd1b37a91bd15.svg";
export { ForwardRef as ReactComponent };